// extracted by mini-css-extract-plugin
module.exports = {"iconText":"Card_iconText__13UJY"};